import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';

export const HeaderMenu = styled(AntMenu)`
  background: var(--coolest-gray-10);
  padding: 0;
  border: 0;

  &.ant-menu-horizontal {
    > .ant-menu-item {
      border-bottom-color: transparent;
    }
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after {
    border-bottom: none;
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after {
    border-bottom: none;
  }
  &.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item:not(:hover)::after {
    border-bottom: none !important;
  }
`;

const MenuListComponent = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  > li a {
    display: block;
    padding: var(--spacing-03);
    border-radius: var(--border-radius-small);

    > div > svg:last-child {
      display: none;
    }

    &,
    &:hover,
    &:active {
      color: var(--gray-100);
    }

    &:hover {
      background: var(--coolest-gray-20);
    }

    &.active {
      background: var(--blue-20);
      > div > svg:last-child {
        display: inline-block;
      }
    }
  }

  > li > span {
    display: block;
    padding: var(--spacing-03);
  }
`;

const MenuListHeader = styled.strong`
  display: block;
  padding: var(--spacing-03) var(--spacing-05);
`;

type MenuListType = typeof MenuListComponent & {
  Header: typeof MenuListHeader;
};

const MenuList: MenuListType = MenuListComponent as any;

MenuList.Header = MenuListHeader;

export { MenuList };
